import { configureStore } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import poems from './poemsSlice';
import auth from '../features/auth/authSlice';

import { apiSlice } from './apiSlice';

export const store = configureStore({
  reducer: {
    poems,
    auth,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
